module.exports = (__webpack_require__(0))(125);


//////////////////
// WEBPACK FOOTER
// delegated ./src/version.js from dll-reference girder_lib
// module id = 146
// module chunks = 0